import { ISitesHasLanguages } from '@llws/lift-entity-interfaces';
import { Equal, QueryStringCommandOptions } from '@/shared';
import { StoreBaseImplementation } from '@/shared/classes/store-base-implementation';

// Base store configuration
const adminGatewayResourcePath: string = '/website-api/sites/:param/sites_has_languages';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: QueryStringCommandOptions = {};
const defaultGetSingleFilters: QueryStringCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementation<ISitesHasLanguages>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'sites-has-languages/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
